import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Datepicker from "components/Input/Datepicker/Datepicker";
import s from "./CreateContent.module.scss";

const CreateContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const settleDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
      ? ""
      : null;
    if (type === "start") {
      handleInput(date, "settleDate");
    }
  };
  const settleDateOnFocus = () => {
    setFocus({ settleDate: true });
  };
  const settleDateOnBlur = () => {
    setFocus({ settleDate: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <Datepicker
          label={t(
            "page.finance.bankfile.by.settlement.date.create.function.dialog.content.1",
          )}
          mandatory
          type="start"
          noErrorMessage
          onchangeFn={settleDateOnChange}
          onfocusFn={settleDateOnFocus}
          onblurFn={settleDateOnBlur}
          sxParams={{ datepickerFocus: focus.settleDate }}
        />
      </div>
    </div>
  );
};

export default React.memo(CreateContent);
